<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Политики конфиденциальности</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="gde-ispolzyetsya"
            class="typography__headline2"
            >Где используются
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              Политика конфиденциальности (или просто Политика)&nbsp;&mdash; документ, в&nbsp;котором
              вы&nbsp;описываете, какие пользовательские данные клиентов вы&nbsp;собираете и&nbsp;зачем это делаете.
            </p>

            <p>
              Пользовательские данные включают в&nbsp;себя информацию, по&nbsp;которой можно найти или идентифицировать
              пользователя: фамилия-имя, домашний адрес, телефон, место работы, электронный адрес, фотографии.
            </p>

            <p>
              Помимо политики конфиденциальности, по&nbsp;необходимости, используются и&nbsp;другие документы, например
              пользовательское соглашение, описание cookie или согласие на&nbsp;передачу данных.
            </p>

            <p>
              В&nbsp;MyDonut нужные документы вы&nbsp;можете использовать на&nbsp;формах оформления заказов, записей
              и&nbsp;заявок, а&nbsp;также в&nbsp;уведомлении о&nbsp;cookie.
            </p>

            <p>Какие где документы разместить вы&nbsp;решаете сами.</p>
          </div>
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="dobavlenie-i-redaktirovanie-stranis"
            class="typography__headline2"
          >
            Добавление и редактирование страниц
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Давайте добавим и&nbsp;заполним страницы с&nbsp;этими данными для вашего сайта.</p>

            <p>В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Сайт&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/politiki-konfidencialnosti-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            На&nbsp;открывшейся странице выберите в&nbsp;меню слева раздел &quot;Раздел&quot;О компании&quot;&quot;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/politiki-konfidencialnosti-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              На&nbsp;сайте будет доступен отдельный раздел со&nbsp;всеми добавленными страницами, среди которых будут
              ваши политики.
            </p>

            <p>Добавьте новую информационную страницу по&nbsp;кнопке &laquo;Добавить страницу&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/politiki-konfidencialnosti-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>После добавления новой страницы можно будет перейти к&nbsp;её&nbsp;настройке и&nbsp;редактированию.</p>

            <p>
              По-умолчанию она скрыта с&nbsp;сайта, чтобы можно было сначала её&nbsp;настроить и&nbsp;показать когда
              будет готова.
            </p>

            <p>Ниже нужно ввести название страницы и&nbsp;можно задать ей&nbsp;конечную ссылку для открытия.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/politiki-konfidencialnosti-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Теперь можно перейти к&nbsp;редактированию содержания страницы по&nbsp;кнопке &laquo;Редактировать
            страницу&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/politiki-konfidencialnosti-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              Справа откроется редактор, в&nbsp;котором можно ввести текст, добавить изображения и&nbsp;другие нужные
              элементы.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; над редактором.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/politiki-konfidencialnosti-6.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>После сохранения, справа можно посмотреть превью получившейся страницы.</p>

            <p>
              Таким&nbsp;же образом добавьте все нужные вам страницы с&nbsp;политиками и&nbsp;скопируйте от&nbsp;сюда
              на&nbsp;них ссылки.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/politiki-konfidencialnosti-7.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="ispolzovanie-stranis"
            class="typography__headline2"
            >Использование страниц
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              Теперь нужно вставить ссылки на&nbsp;ваши политики в&nbsp;сообщении о&nbsp;cookie и&nbsp;на&nbsp;формах
              оформления.
            </p>

            <p>В&nbsp;меню слева выберите раздел &laquo;Политики и&nbsp;cookie&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/politiki-konfidencialnosti-8.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>В&nbsp;&laquo;Cookie&raquo; можно настроить сообщение о&nbsp;использовании cookie.</p>

            <p>
              Помимо самого текста сообщения, в&nbsp;него нужно вставить ссылку на&nbsp;страницу с&nbsp;описанием
              собираемых данных. Эту страницу необходимо самостоятельно добавить и&nbsp;заполнить в&nbsp;настройках
              сайта в&nbsp;разделе &laquo;О&nbsp;компании&raquo;, описанном выше. Также перейти в&nbsp;раздел можно
              нажав здесь &laquo;Редактировать страницы&raquo;.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/politiki-konfidencialnosti-9.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Заказы&raquo; можно настроить текст о&nbsp;принятии политик на&nbsp;странице оформления
              заказа.
            </p>

            <p>
              Помимо самого текста сообщения, в&nbsp;него нужно вставить ссылки на&nbsp;страницы с&nbsp;описанием
              политик. Эти страницы необходимо самостоятельно добавить и&nbsp;заполнить в&nbsp;настройках сайта
              в&nbsp;разделе &laquo;О&nbsp;компании&raquo;, описанном выше. Также перейти в&nbsp;раздел можно нажав
              здесь &laquo;Редактировать страницы&raquo;.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/politiki-konfidencialnosti-10.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Записи&raquo; можно настроить текст о&nbsp;принятии политик на&nbsp;странице оформления
              записи.
            </p>

            <p>
              Помимо самого текста сообщения, в&nbsp;него нужно вставить ссылки на&nbsp;страницы с&nbsp;описанием
              политик. Эти страницы необходимо самостоятельно добавить и&nbsp;заполнить в&nbsp;настройках сайта
              в&nbsp;разделе &laquo;О&nbsp;компании&raquo;, описанном выше. Также перейти в&nbsp;раздел можно нажав
              здесь &laquo;Редактировать страницы&raquo;.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/politiki-konfidencialnosti-11.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Заявки&raquo; можно настроить текст о&nbsp;принятии политик на&nbsp;странице оформления
              заявки.
            </p>

            <p>
              Помимо самого текста сообщения, в&nbsp;него нужно вставить ссылки на&nbsp;страницы с&nbsp;описанием
              политик. Эти страницы необходимо самостоятельно добавить и&nbsp;заполнить в&nbsp;настройках сайта
              в&nbsp;разделе &laquo;О&nbsp;компании&raquo;, описанном выше. Также перейти в&nbsp;раздел можно нажав
              здесь &laquo;Редактировать страницы&raquo;.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/politiki-konfidencialnosti-12.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>После настройки всех политик, не&nbsp;забудьте опубликовать изменения на&nbsp;сайт.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/politiki-konfidencialnosti-13.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Как настроить политики разобрались. Самое время перейти к
            <BaseLink
              class="ui-link-secondary"
              to="/faq/articles/sayt-dlya-klientov"
              >изучению сайта для клиентов
            </BaseLink>
            .
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Сайт",
    url: "/faq/categories/sayt",
  },
  {
    name: "Политики конфиденциальности",
  },
];

const menu = [
  {
    name: "Где&nbsp;используются",
    url: "gde-ispolzyetsya",
  },
  {
    name: "Добавление&nbsp;и&nbsp;редактирование страниц",
    url: "dobavlenie-i-redaktirovanie-stranis",
  },
  {
    name: "Использование&nbsp;страниц",
    url: "ispolzovanie-stranis",
  },
];

const relatedArticles = [
  {
    name: "Сайт для клиентов",
    slug: "sayt-dlya-klientov",
  },
  {
    name: "Конструктор сайта",
    slug: "konstruktor-sayta",
  },
  {
    name: "Информационные страницы",
    slug: "informatsionnyye-stranitsy",
  },
];

useSeoMeta({
  title: "Политики конфиденциальности",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
